import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=a641a128&scoped=true"
import script from "./addShop.vue?vue&type=script&lang=js"
export * from "./addShop.vue?vue&type=script&lang=js"
import style0 from "./addShop.vue?vue&type=style&index=0&id=a641a128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a641a128",
  null
  
)

export default component.exports